try {
  document.querySelector(':focus-visible');
} catch (error) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  let keys = [
    'ArrowUp',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    'Tab',
    'Enter',
    'Space',
    'Escape',
    'Home',
    'End',
    'PageUp',
    'PageDown',
  ];
  let isMouse = false;
  let lastActiveElement = null;

  window.addEventListener('keydown', (event) => {
    if (keys.includes(event.code)) {
      isMouse = false;
    }
  });

  window.addEventListener('mousedown', () => {
    isMouse = true;
  });

  window.addEventListener(
    'focus',
    (event) => {
      if (lastActiveElement) {
        lastActiveElement.classList.remove('focused');
      }

      if (!isMouse) {
        lastActiveElement = document.activeElement;
        lastActiveElement.classList.add('focused');
      }
    },
    true
  );
}
